import { Button, Group, Modal, Stack, Text, TextInput } from '@mantine/core';
import { REJECT_CATEGORIES, type RejectCategory } from '../lib/api.js';

export interface RejectModalProps {
  opened: boolean;
  onClose: () => void;
  note: string;
  onNoteChange: (n: string) => void;
  /** Ein Klick auf einen Grund = speichern + sofort zum nächsten Inserat. */
  onPick: (c: RejectCategory) => void;
  pending: boolean;
}

export function RejectModal(props: RejectModalProps): JSX.Element {
  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title="Warum nicht?"
      centered
      size="sm"
      radius="lg"
    >
      <Stack gap="md">
        <Text size="sm" c="dimmed">
          Top-Treffer abgelehnt — was war's? <b>Ein Klick speichert und geht weiter.</b>
        </Text>

        <TextInput
          label="Notiz (optional, vor dem Klick eintippen)"
          placeholder="z.B. Stadtteil zu laut"
          value={props.note}
          onChange={(e) => props.onNoteChange(e.currentTarget.value)}
        />

        <Stack gap={6}>
          {REJECT_CATEGORIES.map((c) => (
            <Button
              key={c.value}
              variant="light"
              color="red"
              size="md"
              disabled={props.pending}
              onClick={() => props.onPick(c.value)}
              justify="flex-start"
              leftSection={c.icon}
            >
              {c.label}
            </Button>
          ))}
        </Stack>

        <Group justify="flex-end" gap="xs">
          <Button variant="subtle" color="gray" onClick={props.onClose} disabled={props.pending}>
            Abbrechen
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
